<template>
    <component :is="tag">
        <slot
            :brief="brief"
            :is-loading="isLoading"
            :errors="errors"
            :error-message="errorMessage"
            :task="task"
            :content="content"
            :go-to-content="handleGoToContent"
        />
    </component>
</template>

<script>
    import BaseActivationBriefStepMixin from '../mixins/BaseActivationBriefStepMixin';
    import ContactsMixin from '../mixins/ContactsMixin';
    import ActivationBriefTasksMixin from '../mixins/ActivationBriefTasksMixin';
    import { useFeatureFlagsStore } from '../../../../stores';
    import { computed } from 'vue-demi';
    import useRouter from '../../../../src/composables/use-router';

    const COMPLETED_AI_JOB_STATUS = 'completed';

    export default {
        name: 'ActivationDeliveredContentProvider',
        mixins: [ContactsMixin, BaseActivationBriefStepMixin, ActivationBriefTasksMixin],

        data() {
            return {
                isLoading: false
            };
        },

        setup() {
            const featureFlags = useFeatureFlagsStore().data;
            const router = useRouter().get();

            const showCreatorContentMetrics = computed(() => {
                return featureFlags['creator-content-metric-screenshots'] || false;
            });

            const goToRedirectionPage = (task) => {
                router.push({
                    name: 'v2.activation.brief.task.delivery.redirection',
                    params: {
                        brief_id: task.brief_id,
                        task_id: task.id
                    }
                });
            };

            return {
                showCreatorContentMetrics,
                goToRedirectionPage
            };
        },

        async created() {
            this.isLoading = true;
            try {
                await this.loadContact(true);
                await this.loadActivationBrief(true);
                await this.loadActivationTaskContent();

                if (!this.showCreatorContentMetrics) {
                    this.goToRedirectionPage(this.task);
                }
            } catch (error) {
                this.handleHttpError(error);
            }
            this.isLoading = false;
        },

        computed: {
            content() {
                const manualTaskContent =
                    this.taskContent?.filter((taskContent) =>
                        ['tag', 'influencer', 'crawler', 'account'].includes(taskContent.source)
                    ) || [];

                const complete = [];
                const incomplete = [];

                manualTaskContent.forEach((content) => {
                    if (
                        content.insights_stored_at ||
                        content.manual_stats_updated_at ||
                        content.ai_parsing_job_status === COMPLETED_AI_JOB_STATUS
                    ) {
                        complete.push(content);
                    } else {
                        incomplete.push(content);
                    }
                });
                return {
                    complete,
                    incomplete
                };
            }
        },

        methods: {
            handleGoToContent(contentId) {
                this.$router.push({
                    name: 'v2.activation.brief.task.content.metrics',
                    params: { content_id: contentId }
                });
            }
        }
    };
</script>
